import { Fragment } from 'react';

import ImportInfo from '../ImportInfo';
import ImportDetail, { importShape } from '../ImportDetail';

const Import = ({ lastImport }) => (
    <Fragment>
        <ImportInfo />
        {lastImport && <ImportDetail {...lastImport} />}
    </Fragment>
);

Import.propTypes = {
    lastImport: importShape,
};

Import.defaultProps = {
    lastImport: null,
};

export default Import;
